import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles(MUITheme => ({
  paginationContainer: {
    position: 'relative',
    textAlign: 'center',
    '@media(max-width: 1200px)': {
      display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end'
    },
    '@media(max-width: 960px)': { flexDirection: 'column' }
  },

  pageListformControl: {
    width: 72,
    margin: "0 12px 0 15px",
    "& div": {
      "& div": { padding: "8px 13px" },
    },
    "& fieldset": {
      paddingLeft: "0 !important",
      top: 0,
      "& + div": {
        "& div": {
          padding: "8.5px 13px",
          color: MUITheme.palette.text.darkGrey,
        },
      },
      "& legend": { display: "none" },
    },
  },
  pageCountSection: {
    display: "flex",
    alignItems: "center",
    position: 'absolute',
    right: 0,
    top: '50%',
    transform: 'translateY(-50%)',
    "& span": {
      color: MUITheme.palette.text.lightGrey,
      fontSize: 14,
    },
    '@media(max-width: 1200px)': { 
      position: 'static',
      transform: 'translateY(0)'
    },
  },
  styledPagination: {
    // float:"right",
    // paddingRight:"60px",
    // overflow:"hidden",
    // height: "30px",
    "& button": { color: "#4a4a4a", borderRadius: "50%",  width: "40px", height: "40px", margin: "4px", '&:hover':{ cursor:"pointer",}},
    "& .MuiFlatPagination-rootCurrent": {
      padding: "0 4px",
      backgroundColor: MUITheme.palette.background.white,
      color: `${MUITheme.palette.text.white} !important`,
      borderRadius: "50%",
      maxWidth: "40px",
      maxHeight: "40px",
    },
    "& .MuiFlatPageButton-rootEnd": {
      color: "#4a4a4a",
      fontWeight: 600,
      borderRadius: "50%"
    },
    "& .MuiFlatPageButton-rootEnd.Mui-disabled": {
      color: "rgba(155,155,155,0.5) !important",

    },
    "@media(max-width: 600px)": {
      float: "left", 
      "& .MuiFlatPagination-rootCurrent": {
        padding: 0,
        //background: MUITheme.palette.background.btnBg,
        margin:"0 auto", 
        borderRadius:0,
        width:"30px",
        height:"30%",
        color: `${MUITheme.palette.text.white} !important`,
      },
    "& button": {
       color: "#4a4a4a", 
       borderRadius: 0,  
       width: "30px", 
       height: "30px", 
       margin: 4, 
       '&:hover':{ cursor:"pointer",}},
    }
  },
  visibility:{
    '& .MuiButton-root.Mui-disabled':{
      visibility:"hidden",
      '&::before':{
        width: "5px",
        height: "6px",
        content: "''",
        display: "inline-block",
        background: "#CF3C32",
        borderRadius: "50%",
        marginRight: "5px"
    }
    }
  }
}));
